import { MergeButton } from './MergeButton'
import { LayerChange } from 'providers/LayerChangesProvider/types'
import { observer } from 'mobx-react-lite'
import { useRootStore } from 'stores/RootStore'
import { Item } from 'components/CollabItem/Item'

interface Props {
  trackedChange: LayerChange
}

export const MergeTrackedChangeControl = observer(function MergeTrackedChangeControl({ trackedChange }: Props) {
  const rootStore = useRootStore()
  const docStore = rootStore.docStore

  if (!docStore) {
    return null
  }

  const { accept, canAcceptChanges } = docStore.trackedChangesStore

  const handleMerge = () => accept([trackedChange.uuid])

  return (
    <Item.Control tooltipTitle={!canAcceptChanges ? 'You do not have access to merge' : undefined}>
      <MergeButton onPress={handleMerge} isDisabled={!canAcceptChanges} />
    </Item.Control>
  )
})
